/**
 * Vario-Route-Kontext aus der iframe-URL.
 *
 * Vario haengt beim Einbetten Parameter an die App-URL. Gemessen am 2026-08-09 in der laufenden
 * App (DevTools, `iframe.src`) im Tab „Angebote" des Kanals Kaufland NL:
 *
 *   routeName=saleschannels.saleschannel.app  channelType=MARKETPLACE  id=1535941123462754304
 *
 * `1535941123462754304` ist genau die `vario_channel_id`, die `account.kaufland_storefronts`
 * fuer `nl` fuehrt. Damit laesst sich der Tab auf den Kanal vorbelegen, aus dem er geoeffnet
 * wurde.
 *
 * Dokumentiert ist davon nichts — weder im vendorten Framework-Snapshot noch im
 * Developer-Portal. Aendert Vario die Parameter, liefert diese Funktion `null` und die
 * Vorbelegung faellt auf ihren Fallback zurueck; nichts bricht.
 */

/** Route, in der `id` einen Verkaufskanal bezeichnet. */
const SALES_CHANNEL_ROUTE = 'saleschannels.saleschannel.app';

/**
 * Verkaufskanal-ID aus der URL, oder `null`.
 *
 * `id` ist bei Vario der Bezeichner der AKTUELLEN Route, nicht speziell der eines
 * Verkaufskanals — in einer Artikel-Route steht dort eine Artikel-ID. Deshalb zaehlt der Wert
 * nur bei passendem `routeName`.
 */
export function varioSalesChannelId(href: string): string | null {
  let params: URLSearchParams;
  try {
    params = new URL(href).searchParams;
  } catch {
    return null;
  }
  if (params.get('routeName') !== SALES_CHANNEL_ROUTE) return null;
  const id = params.get('id');
  return id && id.trim() !== '' ? id : null;
}

/** Verkaufskanal-ID des laufenden Fensters. Ausgelagert, damit die Logik ohne DOM testbar ist. */
export function currentVarioSalesChannelId(): string | null {
  return varioSalesChannelId(window.location.href);
}
